export function validateEmail(email: string): boolean {
  if (!email.trim()) {
    return false;
  }
  const re =
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return re.test(String(email).toLowerCase()) || email.trim().length === 0;
}

export function validatePhoneByMask(phone: string, mask: string): boolean {
  if (!phone.trim()) {
    return false;
  }
  return phone.length === mask.length;
}

export function validateName(name: string): boolean {
  return Boolean(name.length);
}
